import TableMisions from "./TableMisions";

const useComponentsProjects = () => {
  return { TableMisions };
};
export default useComponentsProjects;
